import { render } from "./DietSettings.vue?vue&type=template&id=797f945b"
import script from "./DietSettings.vue?vue&type=script&lang=js"
export * from "./DietSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__